/**
 * Global loader
 */

// Vendors
import $ from 'jquery';

const loaderTemplate = `
  <div class="global-loading-container">
    <div class="loading loading--rotate">
      <div class="loading__rotate-container">
        <div class="loading__ball"></div>
        <div class="loading__ball"></div>
        <div class="loading__ball"></div>
        <div class="loading__ball"></div>
      </div>
      <div class="loading__rotate-container">
        <div class="loading__ball"></div>
        <div class="loading__ball"></div>
        <div class="loading__ball"></div>
        <div class="loading__ball"></div>
      </div>
      <div class="loading__rotate-container">
        <div class="loading__ball"></div>
        <div class="loading__ball"></div>
        <div class="loading__ball"></div>
        <div class="loading__ball"></div>
      </div>
    </div>
  </div>
`;

class globalLoader {
  constructor() {
    this.isLoading = false;
    this.loader = null;
  }

  show() {
    if (this.isLoading) return;
    this.isLoading = true;
    this.loader = $(loaderTemplate);
    $('body').append(this.loader);
  }

  hide() {
    if (!this.isLoading) return;
    this.isLoading = false;
    this.loader.remove();
  }
}

export default new globalLoader();
